import {CategoryWiseDetail, FacetedItemInfo} from "../autogenerated/ZoomBridge";
import _ from 'lodash';

const debug = require('../debug/debug')('wc:util:FacetUtil');

export function updateCategoryList(
  categoryList: CategoryWiseDetail[],
  categoryId: string,
  selected: boolean,
  facetedItemInfo: FacetedItemInfo
) {
  debug('[updateCategoryList()] args: ', { categoryList, categoryId, selected, facetedItemInfo });
  facetedItemInfo.setSelected(selected);
  //const categoryWiseDetail: CategoryWiseDetail = categoryList.find((c) => c.getCategoryId() === categoryId);
  //same group have same categoryId so check by compare every item in array.

  let categoryWiseDetail: CategoryWiseDetail = categoryList.find((c) => (_.includes(c.getName2count(),facetedItemInfo)));
  if (!categoryWiseDetail) {
    categoryWiseDetail = categoryList.find((c) => c.getCategoryId() === categoryId);
    if(!categoryWiseDetail)
    return;
  }

  let areAnySelected = false;

  // If selected is true, just set hasAnySelectedItem to true and return.
  if (selected) {
    debug('[updateCategoryList()] setting categoryWiseDetail.setHasAnySelectedItem(true)');
    categoryWiseDetail.setHasAnySelectedItem(true);
    return;
  }

  // Else, traverse children and look for at least one that is selected.
  if (categoryWiseDetail.isRecursiveData()) {
    areAnySelected = visitFacetedItemInfos(categoryWiseDetail.getTreeData()[0].getChildren());
  } else {
    areAnySelected = categoryWiseDetail.getName2count().filter((info: FacetedItemInfo) => info.isSelected()).length > 0;
  }

  categoryWiseDetail.setHasAnySelectedItem(areAnySelected);
}

function visitFacetedItemInfos(nodes: FacetedItemInfo[] = []) {
  for (let node of nodes) {
    if (node.isSelected()) {
      return true;
    }

    const areAnySelected = visitFacetedItemInfos(node.getChildren());
    if (areAnySelected) {
      return true;
    }
  }

  return false;
}

export function getLabelWithoutCount(info: CategoryWiseDetail | FacetedItemInfo) {
  const label = info.getLabel();
  return label.replace(/\s\(\d+\)/, '');
}

export function getFilterLabel(categoryId: string, filter: FacetedItemInfo, parent: ?FacetedItemInfo) {
  let prefix;
  if (categoryId === 'keyword') {
    prefix = "keywords/"
  }
  else if (categoryId === "file_type_filter") {
    prefix = "file_type_filter/"
  }
  else {
    prefix = "";
  }
  const label = filter.getLabel();
  return parent ? `${prefix}${parent.getLabel()}/${label}` : `${prefix}${label}`;
}
